import { useMatch } from "react-router-dom";

import { useStoredState } from "storage/state";

const useCurrentOrganization = (): string => {
  const orgMatch = useMatch("/orgs/:organizationName/*");
  const { organizationName: orgFromUrl } = orgMatch?.params ?? {};
  const [lastOrganization] = useStoredState(
    "organizationV2",
    { deleted: false, name: "" },
    "local",
  );
  const organizationName = orgFromUrl ?? lastOrganization.name;

  return organizationName;
};

export { useCurrentOrganization };
